{
  "fireball": {
    "tiles": {
      "frames": [
        [0, 0],
        [16, 0],
        [32, 0],
        [48, 0],
        [64, 0],
        [0, 16],
        [16, 16],
        [32, 16],
        [48, 16],
        [64, 16],
        [0, 32],
        [16, 32],
        [32, 32],
        [48, 32],
        [64, 32]
      ],
      "speed": 0.6
    },
    "size": {
      "width": 16,
      "height": 16
    }
  }
}
